import store from "./store";
import Axios from "axios";
import { API_BASE_URL, API_X_API_KEY } from "./config/api";

let lang = 'ar';
if (window.localStorage.getItem('lang') !== undefined && window.localStorage.getItem('lang') != null) {
    lang = window.localStorage.getItem('lang');
}
const axios = Axios.create({
    baseURL: `${API_BASE_URL}/`,
    headers: {
        "Content-Type": "application/json",
        "x-language": lang,
        "timezone": 'Asia/Riyadh',
        "x-api-key": API_X_API_KEY
            // "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone
    },
});
axios.interceptors.request.use((config) => {
    //console.log(config);
    config.headers.Authorization = store.state.auth.authToken ?
        "Bearer " + store.state.auth.authToken :
        "";
    return config;
});
export default axios;
